import React, { useState } from 'react';

import { addDays, format, parse } from 'date-fns';
import { DayPicker } from 'react-day-picker';

const now = new Date();

export default function App({ onChange, selected, availableDates }) {

  var selectedObj = {
    from: null,
    to: null
  }
  if (selected && selected.From) {
    console.log("a", selected?.From);
    selectedObj.from = parse(selected.From, "yyyy/MM/dd", new Date());
  }
  if (selected && selected.To) {
    console.log("b");
    selectedObj.to = parse(selected.To, "yyyy/MM/dd", new Date());
  }

  const _handleChange = (range) => {
    var rangeStr = {
      From: null,
      To: null
    }
    if (range) {
      if (range.from) {
        rangeStr.From = format(range.from, "yyyy/MM/dd")
      }

      if (range.to) {
        rangeStr.To = format(range.to, "yyyy/MM/dd");
      }
    }
    onChange(rangeStr);
  }


  let footer = <p>Please pick the first day.</p>;
  if (selectedObj?.from) {
    if (!selectedObj.to) {
      footer = <p>{format(selectedObj.from, 'PPP')}</p>;
    } else if (selectedObj.to) {
      footer = (
        <p>
          {format(selectedObj.from, 'PPP')}–{format(selectedObj.to, 'PPP')}
        </p>
      );
    }
  }

  return (
    <div className="d-flex align-items-center justify-content-center">
    <DayPicker
      ISOWeek
      id="test"
      mode="range"
      defaultMonth={now}
      selected={selectedObj}
      footer={footer}
      onSelect={_handleChange}
      disabled={(day) => {
        return !availableDates.includes(format(day, "yyyy/MM/dd")) // match when month is March
      }}
    />
    </div>
  );
}